<template>
    <div class="rounded shadow-lg modal-content-container">
        <div class="p-4">
            <h4 class="text-center fw-bold">{{ options.title }}</h4>
            <div class="form-group">
                <p>{{ options.message }}</p>
            </div>
            <div class="mt-1 d-flex px-3 justify-content-center">
                <button @click="ok()" type="button" class="btn btn-xs me-2 btn-outline-primary py-2 px-4">
                    {{ options.buttonText }}
                </button>
            </div>
        </div>
    </div>
</template>

<script lang="ts" src="./Alert.ts"></script>
